export const COLORS = {
  BLACK: '#000000',
  WHITE: '#ffffff',
  BLACK_100: '#1B1918',
  PRIMARY: '#f58220',
  BURNT_ORANGE: '#79440b',
  VIBRANT_ORANGE: '#f07c00',
  WARM_AMBER: '#ffb05f',
};
